var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 11.9999L12.0002 13.3333L14.6668 10.6666M14.6668 6.66659H1.3335M14.6668 7.99992V5.46659C14.6668 4.71985 14.6668 4.34648 14.5215 4.06127C14.3937 3.81038 14.1897 3.60641 13.9388 3.47858C13.6536 3.33325 13.2802 3.33325 12.5335 3.33325H3.46683C2.72009 3.33325 2.34672 3.33325 2.06151 3.47858C1.81063 3.60641 1.60665 3.81038 1.47882 4.06126C1.3335 4.34648 1.3335 4.71985 1.3335 5.46659V10.5333C1.3335 11.28 1.3335 11.6534 1.47882 11.9386C1.60665 12.1895 1.81063 12.3934 2.06151 12.5213C2.34672 12.6666 2.72009 12.6666 3.46683 12.6666H8.00016",
    stroke: "#405BD8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardCheck);
export default __webpack_public_path__ + "static/media/credit-card-check.272959f6e4ecac2422031f2d14b105b6.svg";
export { ForwardRef as ReactComponent };